import objectHash from "object-hash";
export default {

    SET_PAGE_LOADING(state, payload) {

        state.pageIsLoading = payload;

    },

    SET_TAXONOMIES(state, payload) {

        state.taxonomies = payload;

    },

    SET_LABELS(state, payload) {

        state.labels = payload;

    },

    SET_SESSION_EXPIRED(state, status){
      state.sessionExpired = status;
    },  

    RESET_SELECTED_BUNDLES(state){
      state.selectedBundles = [];
    },
    SELECT_BUNDLE(state, bundle){
      state.selectedBundles.push(bundle);
    },
    SET_BATCH_LIST(state, list){
      state.batchList = list;
    },
    RESET_BATCH_LIST(state){
      state.batchList = [];
    },
    UNSELECT_BUNDLE(state, bundle){
      state.selectedBundles = state.selectedBundles.filter(b => b.id !== bundle.id);
    },
    SET_SHOW_ARTICLE_PROPERITES_UNIT(state, unit){
      state.showArticlePropertiesTabUnit = unit;
    },
    
    RESET_SHOW_ARTICLE_PROPERTIES_UNIT(state){
      state.showArticlePropertiesTabUnit = '';
    },
    SET_CURRENT_USER(state, user) {

        state.currentUser = user;
        localStorage.setItem('currentUser', JSON.stringify(user));

    },
    SET_VALUE_CHAIN_PROPERTIES_FORM_STATUS(state, status){
      state.valueChainProperties.isFormValid = status;
    },

    SET_VALUE_CHAIN_SAVED(state, status){
      state.valueChainProperties.saved = status;
    },

    SET_ACCESS_TOKEN(state, token) {

        sessionStorage.setItem('authToken', token);

        // set global axios header authorization
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

    },

    LOGOUT(state, payload) {

        state.currentUser = false;
        state.snackbars = [];

        // Alle gespeicherten Daten aus localStorage + sessionStorage entfernen
        sessionStorage.clear();
        localStorage.clear();

        axios.defaults.headers.common['Authorization'] = 'Bearer ';

    },

    SET_SNACKBAR(state, payload) {

        state.snackbars = state.snackbars.concat(payload);

    },

    SET_LANGUAGES(state, payload) {
        state.languages = payload;
    },

    PAGE_TITLE_UPDATED(state, status){
      state.pageTitleUpdated = status;
    },

    SET_CURRENT_LANG_STRING(state, payload) {

        state.lang.currentString = payload;

    },

    SHOW_MODAL_LANGUAGE(state, payload) {

        state.lang.showModal = !state.lang.showModal;

    },

    TOGGLE_CONDITION_BOX_LIST(state,{condition, status}){
      const hash = objectHash(condition);
      const item = {hash, status};
      const index = state.conditionBoxToggleList.findIndex((el) => el.hash === hash);
      if(index === -1){
        state.conditionBoxToggleList.push(item)
      }else{
        state.conditionBoxToggleList.splice(index, 1, item);
      }
    },

    RESET_TOGGLE_CONDITION_BOX_LIST(state){
      state.conditionBoxToggleList = [];
    },

    SET_IS_BUNDLE_ATTRIBUTE(state, status){
      state.isBundleAttribute = status;
      localStorage.setItem('isBundleAttribute', status);
    },
    
    RESET_IS_BUNDLE_ATTRIBUTE(state){
      state.isBundleAttribute = null;
      localStorage.setItem('isBundleAttribute', null);
    }

}
